import { baseThemeShadows } from './shadows'
import whiteLabelBaseTheme, { whiteLabelBaseBorderRadii, whiteLabelBaseDefaultPalette } from './whiteLabelBase'

export const scooponTravelDefaultPalette: App.Design.Palette<string> = {
  ...whiteLabelBaseDefaultPalette,
}

export const scooponTravelShadows: App.Design.Shadows<string> = { ...baseThemeShadows }
export const scooponTravelBorderRadii: App.Design.BorderRadii<string> = { ...whiteLabelBaseBorderRadii }

const scooponTravelTheme: App.Design.Theme = {
  ...whiteLabelBaseTheme,
}

export default scooponTravelTheme
